'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _DefaultString = require('../../helpers/DefaultString');

var _SimpleContactUs = require('./SimpleContactUs.scss');

var _SimpleContactUs2 = _interopRequireDefault(_SimpleContactUs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimpleContactUs = (_dec = (0, _reactRedux.connect)(function (state) {
  return { auth: state.auth, supportEmail: state.appInfo.supportEmail };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SimpleContactUs, _Component);

  function SimpleContactUs() {
    (0, _classCallCheck3.default)(this, SimpleContactUs);
    return (0, _possibleConstructorReturn3.default)(this, (SimpleContactUs.__proto__ || (0, _getPrototypeOf2.default)(SimpleContactUs)).apply(this, arguments));
  }

  (0, _createClass3.default)(SimpleContactUs, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          auth = _props.auth,
          supportEmail = _props.supportEmail;


      var mailtoEmail = supportEmail[auth.productName] ? supportEmail[auth.productName] : supportEmail.DEFAULT;
      var mailtoSubject = 'Stingray Support - ' + auth.productName;
      var mailtoLink = 'mailto:' + mailtoEmail + '?subject=' + mailtoSubject;

      return _react2.default.createElement(
        'div',
        { className: _SimpleContactUs2.default.contactUs },
        _react2.default.createElement(
          'div',
          { className: _SimpleContactUs2.default.title },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.ContactUsTextOnly)
        ),
        _react2.default.createElement(
          'div',
          { className: _SimpleContactUs2.default.contactUsByEmail },
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.ContactUsByEmail)
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'a',
              { href: mailtoLink },
              mailtoEmail
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _SimpleContactUs2.default.contactUsByAddress },
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.ContactUsOrByMailAddress)
          ),
          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.ContactUsByMailAddressCaOnly)
        )
      );
    }
  }]);
  return SimpleContactUs;
}(_react.Component), _class2.propTypes = {
  auth: _react.PropTypes.object,
  supportEmail: _react.PropTypes.object
}, _temp)) || _class);
exports.default = SimpleContactUs;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ContactUs/SimpleContactUs.js
// module id = 1948
// module chunks = 0